export default "__VITE_ASSET__CEzk$qx0__"